export default __webpack_public_path__ + "static/image10-a1f8fc9675af71fc9afbfd99519d3dee.jpg";